/*
 * @Author: zhaoyu zhaoy@normstar.com
 * @Date: 2024-08-07 10:38:34
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-08-07 10:43:58
 * @FilePath: \ns-web-evaluation\pc\src\utils\http.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import createAxios from '@ns/http'
import { useLoading } from '@ns/ui'
import { downloadStream } from '@ns/utils'
import { useUserStoreWithOut } from '@/store/user'
import { useI18n } from '@/hooks/useI18n'
import { parseServerTime } from '@/utils/timezone'

import type { ErrorMessageMode, GetTransformParams } from '@ns/http'
const TIMEOUT_CODE = ['ns402', 'ns401']
const [open, close] = useLoading({ tip: '加载中...' })
export type ShowHttpMessage = (errorMessageMode: ErrorMessageMode, code: string | number) => void
const { createMessage, createWarningModal } = useMessage()
const { portingConfig } = usePortingConfig()
export const showHttpMessage: ShowHttpMessage = function (errorMessageMode, code) {
  const { t } = useI18n()
  const errorMsg = t(`code.${code}`) || t('common.errorHttp')
  if (errorMessageMode === 'modal') {
    createWarningModal({ title: '系统提示', content: () => errorMsg })
  } else if (errorMessageMode === 'message') {
    createMessage.error(errorMsg)
  }
}

const failedHook: GetTransformParams['failedHook'] = function (res, options) {
  const { errorMessageMode } = options
  const { code } = res
  const { logout } = useUserStoreWithOut()
  if (TIMEOUT_CODE.includes(code as string)) {
    logout()
    return
  }
  const errorMessage = '请求出错，请稍后重试'
  showHttpMessage(errorMessageMode, code)
  throw new Error(errorMessage)
}

const errorHook: GetTransformParams['errorHook'] = function ({ errorMessageMode, code }) {
  showHttpMessage(errorMessageMode, code)
}

// 南航安全：浏览器指纹
const browserFingerprint = computed(() => {
  const userAgent = navigator.userAgent
  const language = navigator.language
  const colorDepth = window.screen.colorDepth
  const screenResolution = `${window.screen.width}x${window.screen.height}`
  const canvas = document.createElement('canvas')
  const canvasHash = canvas.getContext
    ? canvas.getContext('2d')?.getImageData(0, 0, 1, 1).data.toString()
    : 'canvasUnsupported'
  return [userAgent, language, colorDepth, screenResolution, canvasHash].join('|')
})

const requestInterceptors: GetTransformParams['requestInterceptors'] = function (config) {
  const { token } = useUserStoreWithOut()
  if (config.headers) {
    config.headers.Authorization = token
    portingConfig.isInnerPersonDisabledInfo &&
      (config.headers['Device-Fingerprint'] = unref(browserFingerprint))
  }
  // 本地包请求全链接处理
  // config.url = getEhomeRequestUrl(config.url)
  return config
}

const responseInterceptors: GetTransformParams['responseInterceptors'] = function (res) {
  const { serverTime } = storeToRefs(useUserStoreWithOut())
  // 统一转换为北京时间（东八区），避免时区问题
  serverTime.value = parseServerTime(res.headers.date)
  return res
}

export const http = createAxios({
  failedHook,
  errorHook,
  requestInterceptors,
  responseInterceptors,
  withCredentials: true,
  downloadStream: async (res) => {
    downloadStream(res)
  },
  beforeRequest: (_config = {}, options) => {
    if (options.loading === true) {
      open()
    }
  },
  afterRequest: () => {
    close()
  },
  requestOptions: {
    apiUrl: '/apiEva'
  }
})
